import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { Button } from 'apps/auth/components/common/Button/Button';
import { CalculatorFrame } from 'apps/auth/components/common/Calculator/styles';
import FeePanel from 'apps/auth/components/common/FeePanel/FeePanel';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { AMOUNT_FROM, AMOUNT_TO } from 'apps/auth/constants/fieldsName';
import { hasGaExceedLimitErrors } from 'apps/auth/services/GASendMultiScreenService';

import GaCalculator from './GaCalculator';

const GaCalculatorScreen = (props) => {
    const isEnable = () => !props.amountFrom.isError && props.amountFrom.value && !props.amountTo.isError && props.amountTo.value;
    const [enabled, setEnabled] = useState(isEnable());

    useEffect(() => {
        const hasErrorsLimits = hasGaExceedLimitErrors(props.amountFrom, props.amountTo);
        const isEnabled = (!props.amountFrom.isError && props.amountFrom.value && !props.amountTo.isError && props.amountTo.value) || hasErrorsLimits;
        setEnabled(isEnabled);
    }, [props.amountFrom, props.amountTo]);

    return (
        <>
            <CalculatorFrame>
                <GaCalculator
                    formName={props.formName}
                    fetchCommissionUrl={props.fetchCommissionUrl}
                    currencyFrom={props.currencyFrom}
                    currencyTo={props.currencyTo}
                    isSend={props.isSend}
                    getValidationError={props.getValidationError}
                    currenciesFrom={props.currenciesFrom}
                    currenciesTo={props.currenciesTo}
                    onSelectCurrencyClick={props.onSelectCurrencyClick}
                    getCurrencyIcon={props.getCurrencyIcon}
                    onIconRenderError={props.onIconRenderError}
                />
                <FeePanel
                    formName={props.formName}
                    fromCurrencyIso={props.currencyFrom?.code}
                    promoCodeFetchUrl={props.promoCodeFetchUrl}
                    beforeSaveMoneyCodeSubmit={props.beforeSaveMoneyCodeSubmit}
                />
            </CalculatorFrame>
            <FixedBottomPanel>
                <Button type="submit" raised={true} disabled={!enabled} onClick={props.onContinueButtonClick} caption={props.continue} />
            </FixedBottomPanel>
        </>
    );
};

GaCalculatorScreen.propTypes = {
    fetchCommissionUrl: PropTypes.string,
    currencyFrom: PropTypes.object,
    currencyTo: PropTypes.object,
    currenciesFrom: PropTypes.array,
    currenciesTo: PropTypes.array,
    isSend: PropTypes.bool,
    getValidationError: PropTypes.func,
    onSelectCurrencyClick: PropTypes.func,
    onContinueButtonClick: PropTypes.func,
    promoCodeFetchUrl: PropTypes.string,
    beforeSaveMoneyCodeSubmit: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => ({
    continue: state.messages.pageMessages.continue,
    amountFrom: state.form[ownProps.formName].fields[AMOUNT_FROM],
    amountTo: state.form[ownProps.formName].fields[AMOUNT_TO],
});

export default connect(mapStateToProps, null)(GaCalculatorScreen);
